import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { testimonials as mockTestimonials } from '../data/mock';
import { getTestimonials } from '../services/api';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';

const TestimonialsSection = () => {
  const [testimonials, setTestimonials] = useState(mockTestimonials);
  const [currentIndex, setCurrentIndex] = useState(0);
  const { language } = useLanguage();
  const t = translations[language];

  const getTranslated = (obj, field) => {
    if (!obj) return '';
    if (language === 'en' && obj[`${field}_en`]) {
      return obj[`${field}_en`];
    }
    return obj[field] || '';
  };

  useEffect(() => {
    const fetchTestimonials = async () => {
      const data = await getTestimonials();
      if (data && data.length > 0) {
        setTestimonials(data);
      }
    };
    
    fetchTestimonials();
  }, []);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  useEffect(() => {
    const interval = setInterval(nextTestimonial, 5000);
    return () => clearInterval(interval);
  }, [testimonials]);

  return (
    <section className="py-24 bg-brand-primary">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-display font-light text-center mb-20 text-brand-accent">{t.testimonialsTitle}</h2>
        
        <div className="max-w-4xl mx-auto">
          <div className="relative">
            <div className="text-center py-12 px-8">
              <p className="text-xl md:text-2xl font-body font-light italic mb-8 text-white leading-relaxed">
                "{getTranslated(testimonials[currentIndex], 'text')}"
              </p>
              <p className="text-lg font-display text-brand-accent">{testimonials[currentIndex].author}</p>
              <p className="text-sm font-body text-brand-accent/80 mt-1">{getTranslated(testimonials[currentIndex], 'role')}</p>
            </div>

            <div className="flex items-center justify-center space-x-4 mt-8">
              <Button 
                variant="outline" 
                size="icon" 
                onClick={prevTestimonial}
                className="bg-transparent border-2 border-brand-accent text-brand-accent hover:bg-brand-accent hover:text-brand-primary rounded-full"
              >
                <ChevronLeft className="w-5 h-5" />
              </Button>
              
              <div className="flex space-x-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    className={`h-2 rounded-full transition-all duration-300 ${
                      index === currentIndex ? 'bg-brand-accent w-8' : 'bg-brand-accent/50 w-2'
                    }`}
                  />
                ))}
              </div>

              <Button 
                variant="outline" 
                size="icon" 
                onClick={nextTestimonial}
                className="bg-transparent border-2 border-brand-accent text-brand-accent hover:bg-brand-accent hover:text-brand-primary rounded-full"
              >
                <ChevronRight className="w-5 h-5" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;